"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBoneProcessRequestT = exports.AutoBoneProcessRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const auto_bone_process_type_js_1 = require("../../solarxr-protocol/rpc/auto-bone-process-type.js");
class AutoBoneProcessRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAutoBoneProcessRequest(bb, obj) {
        return (obj || new AutoBoneProcessRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAutoBoneProcessRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AutoBoneProcessRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    processType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : auto_bone_process_type_js_1.AutoBoneProcessType.NONE;
    }
    static startAutoBoneProcessRequest(builder) {
        builder.startObject(1);
    }
    static addProcessType(builder, processType) {
        builder.addFieldInt8(0, processType, auto_bone_process_type_js_1.AutoBoneProcessType.NONE);
    }
    static endAutoBoneProcessRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createAutoBoneProcessRequest(builder, processType) {
        AutoBoneProcessRequest.startAutoBoneProcessRequest(builder);
        AutoBoneProcessRequest.addProcessType(builder, processType);
        return AutoBoneProcessRequest.endAutoBoneProcessRequest(builder);
    }
    unpack() {
        return new AutoBoneProcessRequestT(this.processType());
    }
    unpackTo(_o) {
        _o.processType = this.processType();
    }
}
exports.AutoBoneProcessRequest = AutoBoneProcessRequest;
class AutoBoneProcessRequestT {
    constructor(processType = auto_bone_process_type_js_1.AutoBoneProcessType.NONE) {
        this.processType = processType;
    }
    pack(builder) {
        return AutoBoneProcessRequest.createAutoBoneProcessRequest(builder, this.processType);
    }
}
exports.AutoBoneProcessRequestT = AutoBoneProcessRequestT;
